import { render, staticRenderFns } from "./RipaContraband.vue?vue&type=template&id=836b5116"
import script from "./RipaContraband.vue?vue&type=script&lang=js"
export * from "./RipaContraband.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports